/**
 * Nested-IA alias route — round 4 / #228.
 *
 * Mounts the MCP marketplace at `/connections/mcp/marketplace` so the
 * Codex full-baseline IA inventory resolves. The flat route at
 * `/connections/marketplace` continues to work; both render the same
 * `MarketplacePage` component.
 */

import { createFileRoute } from '@tanstack/react-router';
import { MarketplacePage } from './marketplace';

export const Route = createFileRoute('/connections/mcp/marketplace')({
  component: MarketplacePage,
});
